<template>
  <Skeleton
      class="chat-widget__settings-button"
      style="height: 30px; width: 200px"
      v-if="appState.initial"
  ></Skeleton>
  <Button class="chat-widget__settings-button chat-widget__how-to" variant="text" :label="buttonTitle" @click="visible = true" icon="pi pi-lightbulb" :title="buttonTitle" v-else/>

  <Dialog v-model:visible="visible" dismissableMask modal :header="buttonTitle" :style="{ width: '75rem' }"
          :breakpoints="{ '1199px': '75vw', '575px': '95vw' }">
    <SunoInstruction v-if="appState.showMusicFields" />
    <StepperComponent v-else />
  </Dialog>
</template>

<script setup>
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Skeleton from "primevue/skeleton";

import {computed, ref} from "vue";
import StepperComponent from "@/modules/chat/components/instruction/StepperComponent.vue";
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import SunoInstruction from "@/modules/chat/components/instruction/Suno/SunoInstruction.vue";

const appState = useAppStateStore();

const visible = ref(false);

const buttonTitle = computed(() => appState.showMusicFields ? 'Инструкция Suno': 'Быстрый старт');

</script>
